import React from 'react';
import { isEmpty } from 'lodash';
import {
  DwtcVAApplicationProcessWrapper,
  DwtcVAApplicationProcessMobileWrapper,
  DwtcVAApplicationProcessHeader,
  DwtcVAApplicationProcessAccordion,
  DwtcVAApplicationProcessButton,
  DwtcVAApplicationProcessHeaderTitle,
  DwtcVAApplicationProcessHeaderText,
  DwtcVAApplicationProcessBody,
  DwtcVAApplicationProcessDisclamier,
  SwiperSlideCardText,
} from '../styles/DwtcVAApplicationProcess.styled';

export default function DwtcVAApplicationProcessMobile({ data, dir }) {
  const [clicked, setClicked] = React.useState(0);

  const toggle = (index) => {
    if (clicked === index) {
      return setClicked(null);
    }

    return setClicked(index);
  }

  return (
    <DwtcVAApplicationProcessWrapper>
      <DwtcVAApplicationProcessMobileWrapper>
        <DwtcVAApplicationProcessHeader>
          <DwtcVAApplicationProcessHeaderTitle>{data.title}</DwtcVAApplicationProcessHeaderTitle>
          <DwtcVAApplicationProcessHeaderText>{data.text}</DwtcVAApplicationProcessHeaderText>
        </DwtcVAApplicationProcessHeader>
        <DwtcVAApplicationProcessBody>
          {isEmpty(data.dwtcVAApplicationProcessList) ||
            data.dwtcVAApplicationProcessList.map((item, index) => (
              <DwtcVAApplicationProcessAccordion key={index}>
                <DwtcVAApplicationProcessButton
                  dir={dir}
                  type="button"
                  onClick={() => toggle(index)}
                  key={index}
                >
                  <h3>
                    {item.content.subtitle}. {item.content.title}
                  </h3>
                  <span className={`${clicked === index ? 'arrow-up' : 'arrow-down'}`} />
                </DwtcVAApplicationProcessButton>
                {clicked === index ? (
                  <SwiperSlideCardText
                    dir={dir}
                    dangerouslySetInnerHTML={{ __html: item.content.text }}
                  />
                ) : null}
              </DwtcVAApplicationProcessAccordion>
            ))}
          <DwtcVAApplicationProcessDisclamier
            dangerouslySetInnerHTML={{ __html: data.vaDisclaimer }}
          />
        </DwtcVAApplicationProcessBody>
      </DwtcVAApplicationProcessMobileWrapper>
    </DwtcVAApplicationProcessWrapper>
  );
}
